import Axios from "@/plugins/Axios";

const BASE_URL = "v1/epublic/notificacoes";

export class NotificacoesService {
  async listarMinhasNotificacoes() {
    const response = await Axios().get(BASE_URL);
    return response.data;
  }

  async marcarTodasComoLidas() {
    const response = await Axios().get(`${BASE_URL}/marcar-todas-lidas`);
    return response.data;
  }

  async visualizarNotificacao(id) {
    const response = await Axios().get(`${BASE_URL}/preview/${id}`);
    return response.data;
  }

  async excluirNotificacao(id) {
    const response = await Axios().delete(`${BASE_URL}/${id}`);
    return response.data;
  }

  async excluirTodasNotificacoes() {
    const response = await Axios().delete(`${BASE_URL}/destinatario`);
    return response.data;
  }
}

export default new NotificacoesService();
